<h4>Payment Terms</h4>
<div class="flex flex-wrap">
    <!-- Row 1 -->
    <div class="w-6 pr-3 mb-3">
        <label class="mb-3">Frequency:</label>
        <p-dropdown 
            [options]="frequency"
            (onChange)="frequencyChanged()"
            [(ngModel)]="paymentTermsModel.selectedFrequency"
            optionLabel="name"
            optionDisabled="disabled"
            placeholder="Select Frequency" />
    </div>
    <div class="w-6">
        <label class="mb-3">Payment Period:</label>
        <p-dropdown 
            [options]="paymentPeriod"
            (onChange)="periodChanged()"
            [(ngModel)]="paymentTermsModel.selectedPeriod"
            optionLabel="name" 
            placeholder="Select Payment Period" />
    </div>
  
    <!-- Row 2 -->
    <div class="w-6 mb-3">
        <label class="mb-3">Driver Consent?</label>
        <div class="flex flex-row">
            <div class="flex align-items-center w-4">
                <p-radioButton 
                    name="yes" 
                    [value]="true"
                    (ngModelChange)="consentChanged()"
                    [(ngModel)]="paymentTermsModel.driverConsent" 
                    inputId="yes" />
                <label for="yes" class="ml-2">
                    Yes
                </label>
            </div>
            
            <div class="flex align-items-center w-4">
                <p-radioButton 
                    name="no" 
                    [value]="false"
                    (ngModelChange)="consentChanged()"
                    [(ngModel)]="paymentTermsModel.driverConsent" 
                    inputId="no" />
                <label for="no" class="ml-2">
                    No
                </label>
            </div>
        </div>
    </div>
    <div class="w-6"></div>
  
    <!-- Row 3 -->
    <div class="w-6 pr-3 mb-3">
        <p>Estimated Deduction Amount:</p>
        <span class="product-price">P83.00</span>
    </div>
    <div class="w-6">
        <p>Estimated Number of Payments:</p>
        <span class="product-price">50</span>
    </div>
</div>
<hr>
<div class="flex flex-row pb-3">
    <div class="w-6">
        <label class="mb-3">Upload Agreement Document:</label>
        <p-panel>
            <ng-template pTemplate="header">
                <div>
                    <input #productImage multiple style="display: none" type="file" accept=".pdf" (change)="handlePdfChange($event)">
                    <p-button [disabled]="paymentTermsModel.files.length > 0" class="mr-2 add-product-next-btn" label="Choose" icon="pi pi-plus" (onClick)="productImage.click()"></p-button>
                </div>
                <p-button class="add-product-cancel-btn" label="Remove All" icon="pi pi-times" severity="danger" (onClick)="removePdf()"></p-button>
            </ng-template>
            <ng-template pTemplate="body">
                <p-scrollPanel [style]="{ width: '100%', height: '150px' }">
                    <div appDnd (fileDropped)="handlePdfChange($event)">
                        <p *ngIf="paymentTermsModel.pdfUrl.length === 0 && fileErrorMessage.length === 0">Drag and Drop files here to upload.</p>
                        <div *ngIf="!uploadInProgress && paymentTermsModel.pdfUrl && fileErrorMessage.length === 0">
                                <div *ngFor="let image of paymentTermsModel.pdfUrl; let i = index" class="mb-1 flex justify-content-between">
                                    <div>
                                        <img src="XpressApp\assets\images\pdf-icon.png" width="80px" alt="file" />
                                    </div>
                                    <div>
                                        <span>{{paymentTermsModel.files[i].name}}</span>
                                    </div>
                                    <div>
                                        <span>{{paymentTermsModel.files[i].size | filesize}}</span>
                                    </div>
                                    <div>
                                        <p-button class="add-product-next-btn" icon="pi pi-times" (onClick)="removePdf(i)" />
                                    </div>
                                </div>
                        </div>
                        <p-messages *ngIf="fileErrorMessage" [(value)]="fileErrorMessage" [enableService]="false"></p-messages>
                    </div>
                </p-scrollPanel>
            </ng-template>
        </p-panel>
        <p class="mt-3 upload-note">Upload signed terms and conditions, agreement, and amortization schedule. <span class="upload-warning">Accepted Files: .pdf</span></p>
    </div>
</div>